export default __webpack_public_path__ + "static/step1-67fc748b5d06bd0b5b474319095e48bf.jpeg";